import { formatDate, FORMAT } from '../../../lib/utils';

const ReplyItem = ({ item, index }) => {
  return (
    <div
      key={item.id}
      className={`relative ${index === 0 ? 'mt-4' : ''}`}
    >
      <div className='flex'>
        <div className='border rounded-b-xl rounded-r-xl border-b-slate-400 px-2 pt-1 pb-2 w-4/5'>
          <div
            className={`flex-1 mr-8 ${
              item.deletedAt ? 'italic opacity-40' : 'font-semibold'
            }`}
          >
            <div className='break-all'>{item.content}</div>
          </div>
        </div>
      </div>
      <div className='text-[10px] leading-tight opacity-40 ml-1'>
        {formatDate(new Date(item.createdAt))}{' '}
        {formatDate(new Date(item.createdAt), FORMAT.HOURMIN)}
      </div>
      <div
        className={`absolute border-l-[1px] border-slate-400 left-1/2 ${
          index === 0 ? 'h-[18px] top-[-17px]' : 'h-[22px] top-[-21px]'
        }`}
      ></div>
    </div>
  );
};

export default ReplyItem;
